<template>
  <b-card title="Покрытие внешними источниками" class="h-100">
    <div v-if="!sortedCoverage.length" class="text-center text-muted py-2">Нет данных</div>
    <div v-for="item in sortedCoverage" :key="item.source" class="mb-75">
      <div class="d-flex justify-content-between font-small-3">
        <span>{{ item.label }}</span>
        <span><span class="font-weight-bold">{{ formatPercent(item.share, 0) }}</span> <span class="text-muted">· {{ formatNumber(item.artists_count) }}</span></span>
      </div>
      <b-progress :value="item.share * 100" :max="100" height="6px" :variant="shareVariant(item.share)" />
    </div>
    <small class="text-muted">Доля артистов с привязкой к источнику</small>
  </b-card>
</template>

<script>
import { BCard, BProgress } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatPercent } from '@/views/finance/utils'
import { formatNumber } from '@/views/dashboard/sifnf/utils'

export default {
  components: { BCard, BProgress },
  props: {
    coverage: { type: Array, default: () => [] },
  },
  setup(props) {
    const sortedCoverage = computed(() => [...(props.coverage || [])].sort((a, b) => b.share - a.share))
    const shareVariant = share => {
      if (share >= 0.7) return 'success'
      return share >= 0.3 ? 'warning' : 'danger'
    }
    return { sortedCoverage, shareVariant, formatPercent, formatNumber }
  },
}
</script>
